<template>
	<div class="create-container sbw-create-container">
		<div class="create-host">
			<div class="jc-page-header">
				<div class="jc-container">
					<el-page-header show-back-icon :title="$t('sbw.text.sbw')" @back="jumpToUp" class="relative">
						<template slot="content">
							<div class="jc-list__header--right">
								<a :href="Config.EIP_BUY_URL" target="_blank" class="fr buy-info">
									{{ $t('create.text.buyMustKnow') }}
								</a>
							</div>
						</template>
					</el-page-header>
				</div>
			</div>
			<div class="jc-page-content">
				<div class="jc-container" style="position:relative;">
					<div class="buildTab">
						<ul>
							<li id="prepaid" @click="setTab('prepaid')" class="hover">
								{{ $t('create.text.yearlyOrMonthly') }}
								<div class="jc-badge-discount">{{ $t('create.text.sale') }}</div>
							</li>
							<li id="postpaid" @click="setTab('postpaid')" v-if="isVip">
								{{ $t('create.text.byConfigurations') }}
							</li>
							<li id="quantities" @click="setTab('quantities')" v-if="isVip">
								{{ $t('create.text.byQuantities') }}
							</li>
						</ul>
					</div>
					<div class="buildCon">
						<div class="infoBox">
							<!-- 地域 -->
							<div class="jc-page-card">
								<div class="jc-page-card-header">
									<h3 class="jc-page-card-title">{{ $t('create.text.region') }}</h3>
								</div>
								<el-form class="jc-form cps-create-form" label-width="130px">
									<!--地域-->
									<el-form-item :label="$t('create.text.region') | withColon">
										<el-radio-group v-model="selectedRegion" @change="regionChange">
											<el-radio-button v-for="(regionName, region, index) in regions" :key="index"
												:label="region">
												{{ regionName }}
											</el-radio-button>
										</el-radio-group>
										<el-tooltip effect="dark" style="margin-left:10px;" placement="right">
											<div slot="content" class="my-os-disk-tip">
												{{ $t('sbw.tooltip.node') }}
											</div>
											<a><i class="jc-icon-question"></i></a>
										</el-tooltip>
									</el-form-item>
								</el-form>
							</div>
							<!-- 带宽 -->
							<div class="jc-page-card">
								<div class="jc-page-card-header">
									<h3 class="jc-page-card-title">{{ $t('create.text.bandwidth') }}</h3>
								</div>
								<el-form class="jc-form cps-create-form" label-width="130px" onsubmit="return false">
									<div id="agreeControlArea">
										<!--带宽计费方式-->
										<el-form-item :label="$t('eip.text.bandwidthCalMode') | withColon">
											<el-radio-group v-model="selectedPaymentType">
												<el-radio-button v-for="(item, index) in BandWidthPaymentTypeConstant"
													:key="index" :label="item.value">
													{{ item.text }}
												</el-radio-button>
											</el-radio-group>
											<el-tooltip class="ml10" effect="dark" placement="right" content="Right Top">
												<div slot="content" class="my-os-disk-tip">
													{{ selectedPaymentType === 'fixed' ? $t('sbw.tooltip.cal') :
														$t('sbw.tooltip.enhanced') }}
													<a :href="selectedPaymentType === 'fixed' ? Config.Band_Width_BillUrl : Config.ENHANCED_BANDWIDTH_URL"
														target="_blank">
														{{ $t('create.tooltip.detail') }}&gt;&gt;
													</a>
												</div>
												<a><i class="jc-icon-question"></i></a>
											</el-tooltip>
										</el-form-item>
										<!--线路-->
										<el-form-item :label="$t('create.text.line') | withColon">
											<el-radio-group v-model="selectedLineType">
												<el-radio-button v-for="(value, key) in lineTypes" :key="key"
													:label="key">{{ value }}
												</el-radio-button>
											</el-radio-group>
											<el-tooltip class="ml10" effect="dark" placement="right" content="Right Top">
												<div slot="content" class="my-os-disk-tip">
													{{ $t('create.tooltip.line', [lineTypes[selectedLineType]]) }}
												</div>
												<a><i class="jc-icon-question"></i></a>
											</el-tooltip>
										</el-form-item>
										<!--保底百分比-->
										<el-form-item v-if="selectedPaymentType === 'enhanced'"
											:label="$t('sbw.text.guaranteedPercentage') | withColon">
											<el-radio-group v-model="selectedPercentage">
												<el-radio-button v-for="(item, index) in GuaranteedPercentageConstant"
													:key="index" :label="item.value">{{ item.text }}
												</el-radio-button>
											</el-radio-group>
										</el-form-item>
										<!--带宽上限-->
										<extra-bandwidth v-model="selectedBandwidth">
										</extra-bandwidth>
									</div>
								</el-form>
							</div>
							<!-- 基本信息 -->
							<div class="jc-page-card">
								<div class="jc-page-card-header">
									<h3 class="jc-page-card-title">{{ $t('create.text.baseInfo') }}</h3>
								</div>
								<el-form class="jc-form cps-create-form" label-width="130px" :model="ruleForm"
									ref="ruleForm" :rules="rules" @submit.native.prevent>
									<!--共享带宽名称-->
									<el-form-item :label="$t('sbw.text.name') | withColon" prop="name" :show-message="false"
										required ref="name">
										<el-input v-model="ruleForm.name" style="width:500px;" placeholder=""
											@blur="ruleFormTag.name = 1" @focus="ruleFormTag.name = 0">
										</el-input>
										<el-tooltip style="margin-left:10px" effect="dark" placement="right">
											<div slot="content" class="my-os-disk-tip">
												{{ $t('sbw.tooltip.name') }}
											</div>
											<a><i class="jc-icon-question"></i></a>
										</el-tooltip>
										<p v-if="ruleFormTag.name !== 0 && ruleForm.name == ''"
											class="el-form-item-help-error">
											{{ $t('create.placeholder.nameNull') }}
										</p>
										<p v-else class="el-form-item-help"
											:class="{ 'el-form-item-help-error': this.ruleFormTag.name == 'error' }">
											{{ $t('create.help.instanceNameRule') }}
										</p>
									</el-form-item>
								</el-form>
							</div>
							<!-- 购买量 -->
							<div class="jc-page-card">
								<div class="jc-page-card-header">
									<h3 class="jc-page-card-title">{{ $t('eip.text.buyNo') }}</h3>
								</div>
								<el-form class="jc-form cps-create-form" label-width="130px">
									<!--购买时长-->
									<el-form-item :label="$t('create.text.buyTimeSpan') | withColon"
										v-if="currentMode === 'prepaid'">
										<div class="my-time-length">
											<span style="display:block;float:left;height:30px;line-height:30px;"></span>
											<div class="time-slide">
												<ul class="time-choose cl">
													<!--0折用户-->
													<el-tooltip effect="dark" placement="top"
														v-if="allDiscountedInfo[index - 1].message !== ''"
														:content="allDiscountedInfo[index - 1].message"
														v-for='index in firstNine'>
														<li @click="selectMonth(index)" :class="getClass(index)"
															class="time-discount">
															<i></i>{{ index }}
														</li>
													</el-tooltip>
													<!--普通用户-->
													<li v-for='index in firstNine' @click="selectMonth(index)"
														:class="getClass(index)"
														v-if="allDiscountedInfo[index - 1].message === ''">
														{{ index }}
													</li>
													<!--0折用户-->
													<el-tooltip effect="dark" placement="top"
														v-if="allDiscountedInfo[index + 8].message !== ''"
														:content="allDiscountedInfo[index + 8].message"
														v-for='index in lastThree'>
														<li @click="selectYear(index)" class="time-discount"
															:class="getClass(12 * index)">
															<i></i>{{ index + $tc('create.text.yearUnit', index) }}
														</li>
													</el-tooltip>
													<!--普通用户-->
													<li v-for='index in lastThree' @click="selectYear(index)"
														:class="getClass(12 * index)"
														v-if="allDiscountedInfo[index + 8].message === ''"
														class="time-discount">
														{{ index + $tc('create.text.yearUnit', index) }}
													</li>
												</ul>
											</div>
										</div>
									</el-form-item>
									<!--自动续费-->
									<el-form-item v-if="currentMode === 'prepaid'"
										:label="$t('create.text.autoRenew') | withColon">
										<input id="autoRenewCheckbox" type="checkbox" v-model="autoRenew" />
										<span>{{ $t('create.text.autoRenewTip') }}</span>
										<el-tooltip style="margin-left:10px" effect="dark" placement="right">
											<div slot="content" class="my-app-tip">
												{{ $t('create.tooltip.autoRenew') }}
											</div>
											<a><i class="jc-icon-question"></i></a>
										</el-tooltip>
									</el-form-item>
									<!--数量-->
									<el-form-item :label="$t('create.text.count') | withColon">
										<el-input-number v-model="selectedNumber" :min="1" :max="availableQuotaNumber"
											@input.native="changeSelectedNumber">
										</el-input-number>
										<el-tooltip style="margin-left:10px" effect="dark" placement="right">
											<div slot="content" class="my-app-tip">{{ $t('sbw.tooltip.count') }}
											</div>
											<a><i class="jc-icon-question"></i></a>
										</el-tooltip>
										<p class="el-form-item-help">{{ $t('sbw.tooltip.countTooltip') }}</p>
									</el-form-item>
								</el-form>
							</div>
							<!-- 标签 -->
							<div class="jc-page-card">
								<div class="jc-page-card-header">
									<h3 class="jc-page-card-title">{{ $t('listPage.text.tags') }}</h3>
								</div>
								<el-form class="jc-page-card cps-create-form" :model="tagForm" label-width="130px"
									:rules="tagRules">
									<el-form-item class="code-value-tip" :label="$t('listPage.text.tags') | withColon">
										<jcb-tag-creationform v-model="tagForm.tags" ref="tagForm"
											:regionId="selectedRegion" @error="errorHandler" :strict="tagValidation">
										</jcb-tag-creationform>
									</el-form-item>
								</el-form>
							</div>
						</div>
					</div>
					<!-- 已选配置 -->
					<div id="selected" class="jc-form-create-selected">
						<h3 class="selected-title">
							{{ $t('create.text.selectedConfig') }}</h3>
						<el-form label-width="100px" class="jc-datashow-list">
							<section class="selected-configure">
								<!--地域-->
								<el-form-item :label="$t('create.text.region')">
									<p>
										{{ regions[selectedRegion] | maybeEmpty }}
									</p>
								</el-form-item>
								<!--线路-->
								<el-form-item :label="$t('eip.text.line')">
									<p>{{ lineTypes[selectedLineType] }}</p>
								</el-form-item>
								<!--保底百分比-->
								<el-form-item v-if="selectedPaymentType === 'enhanced'"
									:label="$t('sbw.text.guaranteedPercentage')">
									<p>{{ selectedPercentage + '%' }}</p>
								</el-form-item>
								<!--带宽-->
								<el-form-item :label="$t('create.text.bandwidth')">
									{{ selectedPaymentType === 'fixed' ? $t('eip.help.byBandwidth', [selectedBandwidth]) :
										$t('sbw.text.byEnhanced', [selectedBandwidth]) }}
								</el-form-item>
								<!--购买时长-->
								<el-form-item :label="$t('create.text.buySpan')" v-if="currentMode === 'prepaid'">
									<p v-if="selectedMonth % 12 !== 0">
										{{ selectedMonth }} {{ $tc('create.text.month', selectedMonth) }}</p>
									<p v-else-if="selectedMonth % 12 === 0">
										{{ selectedMonth / 12 }} {{ $tc('create.text.yearUnit', selectedMonth / 12) }}</p>
									<p v-else>--</p>
								</el-form-item>
								<!--购买数量-->
								<el-form-item :label="$t('create.text.buyNum')">
									<p>{{ selectedNumber }}</p>
								</el-form-item>
							</section>
							<!--费用-->
							<section class="selected-cost">
								<h3 class="selected-cost-title">
									{{ $t('create.text.cost') }}</h3>
								<!--计费方式为包年包月-->
								<div v-if="currentMode === 'prepaid'">
									<el-form-item :label="$t('sbw.text.sbw')">
										<p class="form-item-nopadding"
											:class="[totalDiscount > 0 ? '' : 'form-item-bottom']">
											<span class="price">￥{{ discountedPrepaidTotalPrice }}</span>
											<span class="none">{{ calTotalPrice.discountedPrepaidTotalPrice }}</span>
										</p>
									</el-form-item>
									<save-price v-if="totalDiscount > 0" :totalDiscount="favorablePricePerHour"
										:originPrice="totalPrice"></save-price>
								</div>
								<!--计费方式为按配置-->
								<div v-if="currentMode === 'postpaid'">
									<el-form-item :label="$t('create.text.cost')">
										<p class="form-item-nopadding"
											:class="[configurationTotalDiscount > 0 ? '' : 'form-item-bottom']">
											<span class="price">
												{{ $t('eip.text.feePerHour', [discountByConfigurationsTotalPrice]) }}
											</span>
											<span class="none">{{ calTotalPrice.discountedPrepaidTotalPrice }}</span>
											<span class="none">{{
												configurationCalTotalPrice.discountByConfigurationsTotalPrice }}</span>
										</p>
									</el-form-item>
									<p class="month-total-price">
										<span>{{ $t('create.text.configureMonthPay',
											[discountByConfigurationsOneMonthPrice]) }}</span>
										<span class="none">{{
											configurationCalTotalPrice.discountByConfigurationsOneMonthPrice }}</span>
									</p>
									<save-price v-if="configurationTotalDiscount > 0"
										:totalDiscount="configurationTotalDiscount"
										:originPrice="configurationTotalPrice"></save-price>
								</div>
								<!--计费方式为按用量-->
								<div v-if="currentMode === 'quantities'">
									<el-form-item :label="$t('sbw.text.sbw')">
										<p class="form-item-nopadding"
											:class="[totalDiscount > 0 ? '' : 'form-item-bottom']">
											<span class="price">{{ $t('sbw.text.feePerDay',
												[discountedQuantitiesTotalPrice]) }}</span>
											<span class="none">{{ quantitiesCalTotalPrice.discountedQuantitiesTotalPrice
											}}</span>
										</p>
									</el-form-item>
									<save-price v-if="quantitiesTotalDiscount > 0" :totalDiscount="quantitiesTotalDiscount"
										:originPrice="quantitiesTotalPrice"></save-price>
								</div>
							</section>
							<el-button type="primary" size="large" :disabled="buyButtonDisabled" class="my-buy-btn"
								@click="buy">
								{{ $t('create.text.buyNow') }}
							</el-button>
							<!--引导用户用包年包月方式购买-->
							<p v-if="currentMode === 'postpaid'" class="light-grey">
								{{ $t('create.text.yearPackage', [discountedPrepaidTotalPrice]) }}
							</p>
							<!--尚未通过实名认证-->
							<p v-if="!isCertification" style="color:red;margin-top:10px;">
								{{ $t('create.help.noCertification') }}
								<a :href='Config.REALNAME_URL'>
									{{ $t('create.help.goCertificate') }}
								</a>
							</p>
							<!--超过配额-->
							<p v-if="moreThanQuota" style="color:red">
								{{ $t('create.help.exceedQuota') }}{{ $t('create.help.contact') }}
								<a :href="Config.WOKR_URL" target="_blank">{{ $t('create.tooltip.ticket') }}</a>
							</p>
						</el-form>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>


<script>
import VueCookie from 'vue-cookie';
import {
	CreateTypeConstant,
	ServiceCodeConstant,
	BillingTypesConstant,
	PayTypeConstant,
} from '@/common/Constants';
import ExtraBandwidth from '@/components/common/extraBandwidth/ExtraBandwidth';
import SavePrice from '@/components/common/SavePrice';
import { I18nConstant, BandWidthPaymentTypeConstant, GuaranteedPercentageConstant, BandWidthPaymentTypeByQuantitiesConstant } from '@/common/Constants';
import { getUserQuotas, addBandwidthPackageToCar } from '@/api/sbw/create/actions';
import ifCertification from '@/mixins/ifCertification';
import buyTime from '@/mixins/buyTime';
import scrollSelected from '@/mixins/scrollSelected';

import { changeTwoDecimal, mulDecimals, subDecimals } from '@/common/tool';
export default {
	mixins: [ifCertification, buyTime, scrollSelected],
	components: {
		ExtraBandwidth,
		SavePrice
	},
	data() {
		this.BandWidthPaymentTypeConstant = BandWidthPaymentTypeConstant;
		this.GuaranteedPercentageConstant = GuaranteedPercentageConstant;
		return {
			isVip: false,
			// 节点
			selectedRegion: '',
			lineTypes: {},
			// 带宽
			selectedPaymentType: "fixed",
			selectedPercentage: "20",
			selectedBandwidth: 1,
			// 线路
			selectedLineType: '',
			// 表单验证
			ruleForm: {
				name: '',
			},
			ruleFormTag: {
				name: 0,
			},
			rules: {
				name: [
					{
						type: 'string',
						pattern: new RegExp('^[a-zA-Z\\\u4e00-\\\u9fa5]([0-9a-zA-Z\\\u4e00-\\\u9fa5-_.:]{1,127})$'),
						trigger: 'blur'
					}
				]
			},
			// 购买量
			autoRenew: false,
			selectedMonth: 1,
			cutMonth: 0,
			selectedNumber: 1,
			isBuyIng: false,
			// 当前购买模式（包年包月或按配置）
			currentMode: 'prepaid',
			chargeMode: BillingTypesConstant.PREPAID_BY_DURATION,
			// 当前包年包月仅需
			discountedPrepaidTotalPrice: 0,
			totalPrice: 0,
			totalDiscount: 0,
			// 按配置价格
			discountByConfigurationsTotalPrice: 0,
			discountByConfigurationsOneMonthPrice: 0,
			configurationTotalPrice: 0, // 按配置计价总费用
			configurationTotalDiscount: 0, // 按配置计价折扣额
			// 按用量价格
			discountedQuantitiesTotalPrice: 0,
			quantitiesTotalPrice: 0,
			quantitiesTotalDiscount: 0,
			// 页面参数选择
			regions: {},
			otherMonth: 0,
			timeUnit: 3,
			chargeUnit: 3, // 月 计费时长单位 1:小时 2:天 3:月 4:年,
			selectedYear: 1, // 选择年份,
			availableQuotaNumber: 0, // 可用配额
			// 0折用户折扣信息
			allDiscountedInfo: [
				{ message: '' },
				{ message: '' },
				{ message: '' },
				{ message: '' },
				{ message: '' },
				{ message: '' },
				{ message: '' },
				{ message: '' },
				{ message: '' },
				{ message: '' },
				{ message: '' },
				{ message: '' },
			],
			// 前9个月
			firstNine: [1, 2, 3, 4, 5, 6, 7, 8, 9],
			// 后三年
			lastThree: [1, 2, 3],
			tagForm: {
				tags: []
			},
			tagRules: {
			},
			tagValidation: true,
      favorablePricePerHour: '', // // 省 = 原价 - 应付
		};
	},
	computed: {
		calTotalPrice() {
			return this.calculatePrepaidTotalPrice();
		},
		configurationCalTotalPrice() {
			return this.configurationsCalculateTotalPrice();
		},
		quantitiesCalTotalPrice() {
			return this.calculateQuantitiesTotalPrice();
		},
		// 超过配额
		moreThanQuota() {
			return this.availableQuotaNumber < this.selectedNumber;
		},
		// 立即购买按钮置灰条件
		buyButtonDisabled() {
			return this.isBuyIng || this.moreThanQuota || !this.isCertification
		}
	},
	watch: {
		selectedRegion(newValue) {
			this.getUserType();
			this.getLineTypes();
			this.getQuota();
			this.getDiscountInfo();
		}
	},
	created() {
		this.getRegion();
	},
	methods: {

		getUserType() {
			const params = {
				region: this.selectedRegion
			};
			Ajax.get('/api/usercenter/describeBaseInfo', params)
				.then((res) => {
					res.data = JSON.parse(res.data.meta);
					if (typeof res.data.edcps_vip !== 'undefined') {
						this.isVip = res.data.edcps_vip.toString() === '1';
					}
					this.setTab('prepaid')
				})
				.catch(async (err) => {
					const { response } = err.data;
					try {
						const json = await response.json();
						this.$message.error(json.errmsg);
					} catch (ex) {
						console.log(ex);
					}
				});
		},
		getLineTypes() {
			const param = {
				region: this.selectedRegion
			};
			Ajax.get('/api/cps/getLineTypes', param)
				.then((res) => {
					const data = res.data.lineTypes;
					this.lineTypes = data.reduce((prev, cur) => {
						prev[cur.lineType] = cur.lineTypeName;
						return prev
					}, {})
					this.selectedLineType = Object.keys(this.lineTypes)[0];
				}).catch(async (err) => {
					const { response } = err.data;
					try {
						const json = await response.json();
						this.$message.error(json.errmsg);
					} catch (ex) {
						console.log(ex);
					}
				});
		},
		// 只能输入整数
		changeSelectedNumber(val) {
			clearTimeout(this.inputNumberTimeout);
			this.inputNumberTimeout = setTimeout(() => {
				let v = val.target.value;
				v = v.replace(/[^0-9]/ig, '');
				this.selectedNumber = v
			}, 200)
		},
		getClass(num) {
			if (VueCookie.get(this.GLOBALCOOKIE) == I18nConstant.CN || VueCookie.get(this.GLOBALCOOKIE) == null) {
				if (num === this.selectedMonth) {
					return 'cur';
				} if (this.selectedMonth > num) {
					return 'sel';
				}
				return '';
			} if (VueCookie.get(this.GLOBALCOOKIE) == I18nConstant.EN) {
				if (num === this.selectedMonth) {
					if (this.selectedMonth === 1) {
						return 'curSingleEn curEn';
					}
					return 'curEn';
				} if (this.selectedMonth > num) {
					return 'sel';
				}
				return '';
			}
		},
		getQuota() {
			let params = {
				serviceCode: ServiceCodeConstant.CPSBW,
			};
			getUserQuotas(params)
				.then(res => {
					this.availableQuotaNumber = res.data.userQuotas[this.selectedRegion];
				})
				.catch(async (err) => {
					const { response } = err.data;
					try {
						const json = await response.json();
						this.$message.error(json.errmsg);
					} catch (ex) {
						console.log(ex);
					}
				}).finally(() => { });
		},
		getRegion() {
			Ajax.get({
				action: '/getRegions',
				success: (data) => {
					Object.keys(data.regions).forEach(i => {
						const region = data.regions[i].region;
						const regionName = data.regions[i].regionName;
						this.regions[region] = regionName;
					});
					const passedRegion = this.$route.query.region;
					if (passedRegion !== undefined) {
						this.selectedRegion = passedRegion;
					} else {
						this.selectedRegion = data.regions[0].region;
					}
				}
			});
		},
		// 包年包月计算价格
		calculatePrepaidTotalPrice() {
			if (!this.selectedRegion || !this.selectedLineType) {
				return '';
			}
			this.discountedPrepaidTotalPrice = this.$t('create.text.calculating');
			this.totalPrice = this.$t('create.text.calculating');
			this.totalDiscount = this.$t('create.text.calculating');
			const param = {
				cmd: 1, // 操作类型 1、创建；2、续费；3、升降配；4、删除
				region: this.selectedRegion,
				timeUnit: this.timeUnit, // 月
				timeSpan: this.timeUnit === 3 ? this.selectedMonth : this.selectedYear,
				bw: this.selectedBandwidth, // 带宽
				count: this.selectedNumber,
				createType: CreateTypeConstant.SBW,
				lineType: this.selectedLineType,
				billingType: BillingTypesConstant.PREPAID_BY_DURATION,
			}
			// 如果非整数，不计算价格
			if (!/^\d+$/.test(this.selectedNumber)) {
				return false;
			}
			Ajax.get('/api/price/calculateTotalPrice', param).then(res => {
        const { discountedTotalPrice, totalPrice, totalDiscount } = res?.data || {};
				this.discountedPrepaidTotalPrice = changeTwoDecimal(discountedTotalPrice);
				this.totalPrice = changeTwoDecimal(totalPrice);
				this.totalDiscount = totalDiscount;
        this.favorablePricePerHour = totalDiscount ? changeTwoDecimal(subDecimals(totalPrice, discountedTotalPrice)) : null;
			});
			return '';
		},

		configurationsCalculateTotalPrice() {
			if (!this.selectedRegion || !this.selectedLineType) {
				return '';
			}
			const param = {
				cmd: 1, // 创建
				region: this.selectedRegion,
				timeUnit: this.timeUnit, // 月
				timeSpan: this.timeUnit === 3 ? this.selectedMonth : this.selectedYear,
				bw: this.selectedBandwidth, // 带宽
				count: this.selectedNumber,
				lineType: this.selectedLineType,
				createType: CreateTypeConstant.SBW,
				billingType: BillingTypesConstant.POSTPAID_BY_DURATION
			};

			Ajax.get('/api/price/calculateTotalPrice', param).then(res => {
        const { discountedTotalPrice, totalPrice, totalDiscount } = res?.data || {};
				this.discountByConfigurationsTotalPrice = changeTwoDecimal(discountedTotalPrice);
				this.discountByConfigurationsOneMonthPrice = changeTwoDecimal(mulDecimals(mulDecimals(discountedTotalPrice, 24), 30));
				this.configurationTotalPrice = changeTwoDecimal(totalPrice);
				this.configurationTotalDiscount = totalDiscount ? changeTwoDecimal(subDecimals(totalPrice, discountedTotalPrice)) : null;
			})
			return '';
		},

		calculateQuantitiesTotalPrice() {
			if (!this.selectedRegion || !this.selectedLineType) {
				return '';
			}
			this.discountedQuantitiesTotalPrice = this.$t('create.text.calculating');
			this.quantitiesTotalPrice = this.$t('create.text.calculating');
			this.quantitiesTotalDiscount = this.$t('create.text.calculating');
			const param = {
				cmd: 1, // 操作类型 1、创建；2、续费；3、升降配；4、删除
				region: this.selectedRegion,
				timeUnit: this.timeUnit, // 月
				timeSpan: this.timeUnit === 3 ? this.selectedMonth : this.selectedYear,
				bw: this.selectedBandwidth, // 带宽
				ratio: this.selectedPercentage / 100,
				count: this.selectedNumber,
				createType: CreateTypeConstant.SBW,
				lineType: this.selectedLineType,
				billingType: BillingTypesConstant.QUANTITIES_BY_DURATION,
			}
			// 如果非整数，不计算价格
			if (!/^\d+$/.test(this.selectedNumber)) {
				return false;
			}
			Ajax.get('/api/price/calculateTotalPrice', param).then(res => {
        const { discountedTotalPrice, totalPrice, totalDiscount } = res?.data || {};
				this.discountedQuantitiesTotalPrice = changeTwoDecimal(discountedTotalPrice);
				this.quantitiesTotalPrice = changeTwoDecimal(totalPrice);
				this.quantitiesTotalDiscount = totalDiscount ? changeTwoDecimal(subDecimals(totalPrice, discountedTotalPrice)) : null;
			});
			return '';
		},

		selectMonth(selMonth) {
			this.chargeUnit = 3;
			this.timeUnit = 3;
			this.selectedMonth = selMonth;
			this.otherMonth = selMonth;
			switch (selMonth) {
				case 12:
					this.cutMonth = 2;
					break;
				case 24:
					this.cutMonth = 4;
					break;
				case 36:
					this.cutMonth = 6;
					break;
				default:
					this.cutMonth = 0;
			}
		},
		selectYear(selYear) {
			switch (selYear) {
				case 1:
					this.selectedMonth = 12;
					break;
				case 2:
					this.selectedMonth = 24;
					break;
				case 3:
					this.selectedMonth = 36;
					break;
				default:
					this.cutMonth = 0;
			}
			this.selectedYear = selYear;
			this.chargeUnit = 4;
			this.timeUnit = 4;
		},
		jumpToUp() {
			this.$router.push({
				name: 'SbwList',
				query: { region: this.selectedRegion }
			});
		},
		buy() {
			let formValid = true;
			this.$refs.ruleForm.validate((valid) => {
				formValid = valid;
			});
			if (!formValid) {
				return
			}
			this.isBuyIng = true;
			this.createTempOrder();
		},
		// 创建临时订单
		createTempOrder() {
			const param = {
				orderType: 1, // 订单类型 1、新购；2、续费；3、配置变更
				region: this.selectedRegion, // 区域
				lineType: this.selectedLineType, // 线路
				bw: this.selectedBandwidth, // 带宽
				chargeMode: this.chargeMode,
				chargeDuration: this.chargeUnit === 3 ? this.selectedMonth : this.selectedYear, // 计费时长
				chargeUnit: this.chargeUnit, // 计费时长单位 1:小时 2:天 3:月 4:年
				autoRenew: this.autoRenew,
				quantity: this.selectedNumber, // 购买数量
				clientToken: Normal.getClientToken(), // 用于保证请求的幂等性，唯一
				timestamps: Normal.getClientToken(), // 毫秒时间戳
				createType: CreateTypeConstant.SBW, // 创建类型 basic、vpc、eip、sbw,
				// payType: this.currentMode === 'tab1' ? PayTypeConstant.PRE_PAID : PayTypeConstant.POST_PAID,
				name: this.ruleForm.name,
				resourceTags: this.tagForm.tags,
			};
			addBandwidthPackageToCar(param).then((res) => {
				this.isBuyIng = false;
				const orderId = res.data.tempOrderNumber;
				if (orderId !== '' && typeof orderId !== 'undefined') {
					window.location.href = `${this.Config.ORDER_URL}/confirm?buyId=${orderId}&source=1`;
				}
			})
				.catch(async (err) => {
					this.isBuyIng = false;
					const { response } = err.data;
					try {
						const json = await response.json();
						this.$message.error(json.errmsg);
					} catch (ex) {
						console.log(ex);
					}
				});
		},
		setTab(name) {
			let allMenus = document.querySelectorAll('.buildTab li');
			for (let i = 0; i < allMenus.length; i++) {
				allMenus[i].className = '';
			}
			const currentMenu = document.getElementById(name);
			currentMenu.className = 'hover';
			this.currentMode = name;
			if (name === 'quantities') {
				this.BandWidthPaymentTypeConstant = BandWidthPaymentTypeByQuantitiesConstant;
				this.selectedPaymentType = "enhanced";
				this.chargeMode = BillingTypesConstant.QUANTITIES_BY_DURATION;
			} else if (name === 'postpaid') {
				this.BandWidthPaymentTypeConstant = BandWidthPaymentTypeConstant;
				this.selectedPaymentType = "fixed";
				this.chargeMode = BillingTypesConstant.POSTPAID_BY_DURATION;
			} else if (name === 'prepaid') {
				this.BandWidthPaymentTypeConstant = BandWidthPaymentTypeConstant;
				this.selectedPaymentType = "fixed";
				this.chargeMode = BillingTypesConstant.PREPAID_BY_DURATION;
			}
		},

		// 获取折扣信息
		getDiscountInfo() {
			const param = {
				serviceCode: ServiceCodeConstant.CPSBW,
				billType: 2, // 包年包月
				region: this.selectedRegion,
				buyType: 1// 1、新购2、续费3、配置变更
			};
			Ajax.get({
				url: '/api/discount',
				action: '/describeLowestDiscount',
				param,
				success: (data) => {
					if (data.length > 0) {
						for (let i = 0; i < data.length; i++) {
							this.allDiscountedInfo[i].message = data[i].discounts[0].message;
						}
					}
				}
			});
		},
		regionChange() {

		},
		// 添加标签错误处理
		errorHandler(err) {
			console.log(err)
		},
	}
};
</script>

<style lang="scss">
@import '../../../assets/scss/createCommon';
@import '../../../assets/scss/selectedConfigure';
@import '../../../assets/scss/sliderCommon';
@import 'style';
</style>



// WEBPACK FOOTER //
// src/views/sbw/create/Create.vue